function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.46447 13.4645C2.40215 12.5268 3.67392 12 5 12H13C14.3261 12 15.5979 12.5268 16.5355 13.4645C17.4732 14.4021 18 15.6739 18 17V19C18 19.5523 17.5523 20 17 20C16.4477 20 16 19.5523 16 19V17C16 16.2044 15.6839 15.4413 15.1213 14.8787C14.5587 14.3161 13.7956 14 13 14H5C4.20435 14 3.44129 14.3161 2.87868 14.8787C2.31607 15.4413 2 16.2044 2 17V19C2 19.5523 1.55228 20 1 20C0.447715 20 0 19.5523 0 19V17C0 15.6739 0.526784 14.4021 1.46447 13.4645Z",
  fill: "#1ECD96"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 2C7.34315 2 6 3.34315 6 5C6 6.65685 7.34315 8 9 8C10.6569 8 12 6.65685 12 5C12 3.34315 10.6569 2 9 2ZM4 5C4 2.23858 6.23858 0 9 0C11.7614 0 14 2.23858 14 5C14 7.76142 11.7614 10 9 10C6.23858 10 4 7.76142 4 5Z",
  fill: "#1ECD96"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.032 12.8801C19.1701 12.3454 19.7155 12.0238 20.2502 12.1619C21.3229 12.4388 22.2732 13.0642 22.9519 13.9398C23.6307 14.8153 23.9994 15.8915 24.0002 16.9994L24.0002 19.0001C24.0002 19.5524 23.5525 20.0001 23.0002 20.0001C22.448 20.0001 22.0002 19.5524 22.0002 19.0001L22.0002 17.0009C22.0002 17.0008 22.0002 17.001 22.0002 17.0009C21.9997 16.3363 21.7784 15.6904 21.3713 15.1651C20.964 14.6398 20.3938 14.2645 19.7502 14.0984C19.2155 13.9603 18.8939 13.4149 19.032 12.8801Z",
  fill: "#1ECD96"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.0315 0.882084C15.1685 0.347059 15.7133 0.0243853 16.2483 0.161374C17.3238 0.43675 18.2771 1.06225 18.9578 1.93926C19.6386 2.81627 20.0081 3.89491 20.0081 5.00512C20.0081 6.11534 19.6386 7.19397 18.9578 8.07099C18.2771 8.948 17.3238 9.5735 16.2483 9.84887C15.7133 9.98586 15.1685 9.66319 15.0315 9.12816C14.8945 8.59314 15.2172 8.04836 15.7522 7.91137C16.3975 7.74615 16.9695 7.37085 17.3779 6.84464C17.7864 6.31843 18.0081 5.67125 18.0081 5.00512C18.0081 4.339 17.7864 3.69181 17.3779 3.16561C16.9695 2.6394 16.3975 2.2641 15.7522 2.09887C15.2172 1.96189 14.8945 1.41711 15.0315 0.882084Z",
  fill: "#1ECD96"
});

var SvgCompanion = function SvgCompanion(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCompanion, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/companion.a215df67.svg";
export { ForwardRef as ReactComponent };